import moment from "moment";
import Bible from "utils/Bible";
import api from "./api";
import BiblicalPlan from "./BiblicalPlan";
import DateHandler from "./DateHandler";
import { planTypes } from "./planType";
import { READING_ORDERS } from "./readingOrders";

const dateHandler = new DateHandler();

export const syncPlanWithDB = async ({
  readingCalendar,
  updateDelays,
  id,
  shouldTrackDelays,
  blockedWeekDays,
  quantityOfDays,
  quantityOfChapters,
  planType,
  delays,
  headers,
  readingOrder,
} = {}) => {
  return await api.put(
    `/plan/${id}`,
    {
      readingCalendar,
      shouldTrackDelays,
      blockedWeekDays,
      quantityOfDays,
      chaptersPerDay: quantityOfChapters,
      planType,
      readingOrder,
      ...(updateDelays && { delays: delays + 1 }),
    },
    headers
  );
};

export const getInitialReading = (planv2, readingOrder) => {
  let found;

  const bible = new Bible(READING_ORDERS[readingOrder]);

  const completeBibleArray = bible.createArrayByReadingRange({
    startBookIndex: 0,
    startChapter: READING_ORDERS[readingOrder][0].startChapter,
    endBookIndex: READING_ORDERS[readingOrder].length - 1,
    endChapter:
      READING_ORDERS[readingOrder][READING_ORDERS[readingOrder].length - 1]
        .endChapter,
  });

  completeBibleArray.find((item) => {
    return planv2.some((day) => {
      if (
        day.readingStart.book === item.name &&
        day.readingStart.chapter === item.chapter
      ) {
        found = day;
        return true;
      }

      return false;
    });
  });
  return found;
};

const decideOnPlanAlgorithm = ({
  startDate,
  endDate,
  readingStart,
  readingEnd,
  readPlan,
  blockedWeekDays,
  planType,
  quantityOfDays,
  quantityOfChapters,
  readingOrder,
}) => {
  const biblePlan = new BiblicalPlan(READING_ORDERS[readingOrder]);
  if (planType === planTypes.default) {
    return biblePlan.buildPlanCalendar(
      startDate,
      endDate,
      readingStart,
      readingEnd,
      readPlan,
      blockedWeekDays
    );
  }

  if (planType === planTypes.quantityOfDays) {
    return biblePlan.buildPlanCalendarByQuantityOfDays(
      startDate,
      quantityOfDays,
      readingStart,
      readingEnd,
      readPlan,
      blockedWeekDays
    );
  }

  if (planType === planTypes.chaptersPerDay) {
    return biblePlan.buildPlanCalendarByChaptersPerDay(
      startDate,
      readingStart,
      readingEnd,
      Number(quantityOfChapters),
      readPlan,
      blockedWeekDays
    );
  }

  return biblePlan.buildPlanCalendar(
    startDate,
    endDate,
    readingStart,
    readingEnd,
    readPlan,
    blockedWeekDays
  );
};

export const getNextReadingArrayIndex = (plan, reading, readingOrder) => {
  let found;

  const bible = new Bible(READING_ORDERS[readingOrder]);

  const completeBibleArray = bible.createArrayByReadingRange({
    startBookIndex: 0,
    startChapter: READING_ORDERS[readingOrder][0].startChapter,
    endBookIndex: READING_ORDERS[readingOrder].length - 1,
    endChapter:
      READING_ORDERS[readingOrder][READING_ORDERS[readingOrder].length - 1]
        .endChapter,
  });

  completeBibleArray.find((item, index, array) => {
    const nextItem =
      array[index === array.length - 1 ? array.length - 1 : index + 1];
    if (item.book === reading.book && item.chapter === reading.chapter) {
      plan.some((day, index) => {
        if (
          day.readingDetails.some(
            ({ book, chapter }) =>
              book === nextItem.book && chapter === nextItem.chapter
          )
        ) {
          found = index;
          return true;
        }

        return false;
      });
    }

    return false;
  });

  return Number.isSafeInteger(found) ? found : 0;
};

export const challengePlanReplan = async ({
  plan,
  blockedWeekDays,
  planType,
  quantityOfDays,
  quantityOfChapters,
  readingOrder,
}) => {
  const readPlan = plan.filter((day) => day.read);
  const { readingStart } = getInitialReading(plan, readingOrder);
  const { readingEnd, date: nonReadDate } = plan[plan.length - 1];
  const isFirstDay = 0;

  const startDate = dateHandler.decideOnSafeDate(
    blockedWeekDays,
    moment().clone(),
    isFirstDay
  );

  const endDate = moment(nonReadDate);

  let newPlan = decideOnPlanAlgorithm({
    startDate,
    endDate,
    readingStart,
    readingEnd,
    readPlan,
    blockedWeekDays,
    planType,
    quantityOfDays,
    quantityOfChapters,
    readingOrder,
  });

  readPlan.reverse().forEach((readDay) => {
    const indexFound = getNextReadingArrayIndex(
      newPlan,
      readDay.readingEnd,
      readingOrder
    );

    newPlan.splice(indexFound, 0, readDay);
  });

  newPlan = newPlan.map((item, index) => {
    const notUsingIdFromDB = Number.isSafeInteger(item._id);
    item._id = notUsingIdFromDB ? index : item._id;
    return item;
  });

  return newPlan;
};
